import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallersComponent } from './callers.component';

const routes: Routes = [
	{
		path: 'caller-campaigns',
		component: CallersComponent,
	},
];

@NgModule({
	declarations: [],
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class CallersRoutingModule {}
